import { Directive, Input } from '@angular/core';

@Directive({
  selector: 'iris-hint',
  host: {
    class: 'iris-legal-responsive',
    /* eslint-disable @typescript-eslint/naming-convention */
    '[style.color]': '"#5E666B"',
    '[style.float]': 'align === "end" ? "right" : null',
    '[style.margin-top]': 'align === "end" ? "3px" : null',
    '[attr.align]': 'null'
    /* eslint-enable @typescript-eslint/naming-convention */
  },
  standalone: true
})
export class IrisHint {
  @Input() align: 'start' | 'end' = 'start';
}
